











import { Component, Prop, Vue } from "vue-property-decorator";
const defaultRandomColor: Array<string> = [
  "#aff8d7",
  "#f8afc3",
  "#f8e5af",
  "#b4aff8"
];
type RandomBackgroundItem = {
  color: string;
  top: string;
  left: string;
  delay: string;
  style: string;
};
let randomArray: Array<number> | Array<RandomBackgroundItem> = [];
@Component
export default class extends Vue {
  @Prop({ default: 123 }) count!: number;
  created(): void {
    randomArray = [...new Uint8Array(this.count)];
    randomArray = randomArray.map(e =>
      getRandomBackgroundItem(defaultRandomColor)
    );
  }
  get forArray(): Array<RandomBackgroundItem> | Array<number> {
    return randomArray || [1];
  }
}
function getRandomBackgroundItem(
  randomColor: Array<string>
): RandomBackgroundItem {
  let item = {
    color: randomColor[Math.floor(Math.random() * randomColor.length)],
    top: `${100 * Math.random()}%`,
    left: `${100 * Math.random()}%`,
    delay: `${30 * Math.random()}s`,
    style: ""
  };
  item[
    "style"
  ] = `color:${item.color};left:${item.left};top:${item.top};animation-delay:${item.delay};`;
  return item;
}
